import {
  Attribute,
  BelongsTo,
  JsonApiModel,
  JsonApiModelConfig,
} from '@elearnio/angular2-jsonapi';
import { ILTCourseEvent } from './ilt-course/ilt-course-event.model';

@JsonApiModelConfig({
  type: 'training_attachments',
})
export class TrainingAttachment extends JsonApiModel {
  @Attribute({ readonly: true })
  name!: string;

  @Attribute({ serializedName: 'file' })
  url!: string;

  @Attribute({ serializedName: 'trainer_only' })
  trainerOnly!: boolean;

  @Attribute({ serializedName: 'duplicate_from_id' })
  duplicateFromId!: boolean;

  @BelongsTo()
  attachable!: ILTCourseEvent;
}
